import type { GotoItemAction, NavigationAction } from './actions';
import { Actions } from './actions';
import { NAVIGATION_MAX_DEPTH } from './constants';
import type { NavigationState } from 'client-site-chrome-ui/components/molecules/NavigationDrilldown/types';
import type { DrilldownNavItem } from 'client-site-chrome-ui/types/drilldownNavItem';

const createPageFromNavigationItem = (item: DrilldownNavItem, index: number) => ({
  ...item,
  index,
});

export const getInitalState = (navigation: DrilldownNavItem): NavigationState => ({
  currentPage: 0,
  pages: [createPageFromNavigationItem(navigation, 0)],
});

const handlers = {
  [Actions.GO_BACK]: (state: NavigationState) => {
    const previousPage = Math.max(state.currentPage - 1, 0);
    // remove unnecessary pages
    const pagesEnd = previousPage + 2;
    const pages = [...state.pages.slice(0, pagesEnd)];

    return {
      ...state,
      pages,
      currentPage: previousPage,
    };
  },

  [Actions.GOTO_ITEM]: (state: NavigationState, action: NavigationAction) => {
    const {
      payload: { item },
    } = action as GotoItemAction;
    const nextPage = Math.min(state.currentPage + 1, NAVIGATION_MAX_DEPTH);
    const pages = [...state.pages.slice(0, nextPage), createPageFromNavigationItem(item, nextPage)];

    return {
      ...state,
      currentPage: nextPage,
      pages,
    };
  },
};

export const reducer = (state: NavigationState, action: NavigationAction): NavigationState =>
  handlers[action.type](state, action);
